<template>
  <div>
    <el-page-header @back="goBack" content="测评结果设置"></el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span>分类：</span>
          <span class="glay"
          >{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
          >
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>名称：</span>
            <span class="glay">{{ detalisObj.name }}</span>
          </div>
          <div class="fl1">
            <span> 标识：</span>
            <span class="glay">{{ detalisObj.examId }}</span>
          </div>
        </div>

        <div class="flex-box pub-line">
          <div class="fl1">
            <span>解析：</span>
            <span class="glay">{{ detalisObj.schemeName }}</span>
          </div>
          <div class="fl1">
            <span> 题目：</span>
            <span class="glay"
            >共 <i>{{ detalisObj.questions }}</i
            >题，<i>{{ detalisObj.maxScore }}</i
            >分</span
            >
          </div>
        </div>
        <div style="margin-top: 30px">
          <el-button type="primary" @click="handelResultSet" plain
          >指数及人格结果设置
          </el-button
          >
          <el-button @click="goTopic" type="danger" plain
          >返回题目
          </el-button
          >
        </div>
      </div>
    </div>

    <div class="topic-outer">

      <div class="appraisal-center fonts marr" style="margin-top: 10px;width: 100%">
        <el-tabs v-model="activeNames" @tab-click="handleTabClick">
          <el-tab-pane label="分数区间设置" name="fsqj"></el-tab-pane>
          <el-tab-pane label="结果设置" name="jzjg"></el-tab-pane>
        </el-tabs>
        <div>
          <span>维度：</span>
          <span>
            <el-tag
                :class="{ 'tag-marr': true, activeBg: tagIndex == index }"
                v-for="(item, index) in getWDData"
                :key="item.examDimensionId"
                @click="activeEvent(index, item.code, item.name)"
                effect="plain"
            > {{ item.name }}</el-tag
            >
          </span>
        </div>
        <template v-if="activeNames=='jzjg'">
          <div style="margin-top: 20px">
            <span>基准：</span>
            <span>
            <el-tag
                :class="{ 'tag-marr': true,'tag-marrs': true, 'active-bg1': tagJzIndex == index }"
                v-for="(item, index) in getJZData"
                :key="index"
                @click="activeEventJz(index, item.code, item.name)"
                effect="plain"
            > {{ item.name }}</el-tag
            >
          </span>
          </div>
          <div style="margin-top: 20px">
            <el-button type="success" size="small" @click="handleClick('add')"
            >添加结果<i class="el-icon-plus"></i
            ></el-button>
            <span class="subject"
            >共 <i>{{ tagIndex == 0 ? detalisObj.questions : emptyShow(getWDData[tagIndex]).questions }}</i> 题，<i>{{
                tagIndex == 0 ? detalisObj.maxScore : emptyShow(getWDData[tagIndex]).maxScore
              }}</i
            >分
          </span>
          </div>
          <div style="margin-top: 20px">
            <div class="public-table-data">
              <el-table
                  ref="multipleTable"
                  size="medium"
                  :data="getWdResulData"
                  border
                  style="width: 100%"
                  row-key="menuId"
                  v-loading="loading"
              >
                <el-table-column
                    type="index"
                    label="序号"
                    width="60"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="minScore"
                    label="最小值"
                    width="80"
                    align="center"
                >
                </el-table-column>

                <el-table-column
                    prop="maxScore"
                    label="最大值"
                    width="80"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="标题"
                    width="100"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="状态"
                    width="100"
                    align="center"
                >
                  <template slot-scope="scope">
                    <div class="content_div">{{setHtmlData(scope.row.title)}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="content"
                    label="说明"
                    min-width="220"
                    align="center"
                >
                  <template slot-scope="scope">
                    <div class="content_div">{{setHtmlData(scope.row.content)}}</div>
                  </template>
                </el-table-column>

                <el-table-column
                    prop="descr"
                    label="魅力"
                    min-width="220"
                    align="center"
                >
                  <template slot-scope="scope">
                    <div class="content_div">{{setHtmlData(scope.row.suggest)}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    fixed="right"
                    min-width="180"
                >
                  <template slot-scope="scope">
                    <el-button
                        size="mini"
                        @click="handleClick('edit', scope.row)"
                        type="primary"
                        plain
                    >编辑
                    </el-button
                    >
                    <el-button
                        size="mini"
                        @click="handleDelete(scope.row)"
                        type="danger"
                        plain
                    >删除
                    </el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </template>
        <template v-if="activeNames=='fsqj'">
          <div class="public-dialog-form" style="margin-top: 20px">
            <div v-for="(item,index) in qjList" :key="index" style="margin-bottom: 20px">
              <div class="item_contents">
                <div>
                  <div class="input_item">
                    <div class="name">分数区间：</div>
                    <div>
                      <el-input style="width: 260px" v-model="item.minScore" type="number"
                                placeholder="请输入最小分值（大于等于）"></el-input>
                      -
                      <el-input v-model="item.maxScore" style="width: 260px" type="number"
                                placeholder="请输入最大分值（小于等于）"></el-input>
                    </div>
                  </div>
                  <div class="input_item">
                    <div class="name">区间名称：</div>
                    <div>
                      <el-input v-model="item.title" style="width: 260px" placeholder="请输入名称"></el-input>
                    </div>
                  </div>
                </div>
                <div v-if="qjList.length>1" @click="removeQj(index,item)" class="remove_icon"><i
                    class="el-icon-delete"
                    style="color: #c7302f;font-size: 18px"></i>
                </div>
              </div>
              <div>
                <el-button @click="handQjEdit(index,item)" type="primary">保存设置</el-button>
              </div>
            </div>
          </div>
          <div>
            <el-button type="primary" @click="addQj">添加分数区间</el-button>
          </div>
        </template>
      </div>
    </div>

    <!--结果设置-->
    <el-dialog
        title="结果设置"
        :visible.sync="dialogVisible"
        width="720px"
        top="30px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="一级维度">
                <div>{{ resue.name }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if=" resue.name!='综合' && resueJz.name!='全部' ">
              <el-form-item label="二级基准">
                <div>{{ resueJz.name }}</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="最小值" prop="minScore">
                <el-input
                    placeholder="请输入最小值"
                    v-model="params.minScore"
                    type="number"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最大值" prop="maxScore">
                <el-input
                    placeholder="请输入最大值"
                    v-model="params.maxScore"
                    type="number"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="标题" prop="name">
                <el-input
                    placeholder="请输入标题"
                    v-model="params.name"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="状态" prop="content">
            <rich-text v-if="innerVisible" :keyWord="'title'" :params="params?params:''"></rich-text>
          </el-form-item>
          <el-form-item label="说明" prop="content">
            <rich-text v-if="innerVisible" :keyWord="'content'" :params="params?params:''"></rich-text>
          </el-form-item>
          <el-form-item label="魅力" prop="suggest">
            <rich-text v-if="innerVisible" :keyWord="'suggest'" :params="params?params:''"></rich-text>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>

import {isEmpty, emptyShow} from "@utils/tools/index";
import {ossUpload} from "@utils/filters/upload";
import OperationConfirmation from "../../../components/OperationConfirmation";
import richText from "../../../components/richText";
import Test from "../../WechatConfiguration/Test";

export default {

  filters: {
    //当渲染的文字超出30字后显示省略号
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 60) {
        return value.slice(0, 60) + "...";
      }
      return value;
    }
  },


  data() {
    return {
      //灵魂条件
      isMoer: true,
      srcList: [],
      conditionDialogVisible: false,
      conditionWDData: [],
      conditionInfo: {},
      listCondition: [],
      //之前的代码
      emptyShow, isEmpty,
      detalisObj: {},
      getWDData: [], //维度列表
      getWdResulData: [], //维度结果列表
      tagIndex: 0,
      resue: {},
      loading: false,
      dialogVisible: false,
      params: {},
      clickType: "",
      rules: {
        minScore: [
          {
            required: true,
            message: "请填写正确的分值",
            trigger: "change",
          },
        ],
        maxScore: [
          {
            required: true,
            message: "请填写正确的分值",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请填写状态",
            trigger: "change",
          },
        ],
        content: [
          {
            required: true,
            message: "请填写入说明",
            trigger: "change",
          },
        ],
      },
      resueJz: {},
      getJZData: [],
      tagJzIndex: 0,
      operationVisible: false,
      numType: false,
      innerVisible: false,
      activeNames: 'fsqj',
      qjList: [
        {
          minScore: 0,
          maxScore: 0,
          title: '低',
        },
        {
          minScore: 0,
          maxScore: 0,
          title: '高',
        }
      ],
    };
  },
  components: {
    Test,
    OperationConfirmation,
    richText
  },
  computed: {
    conditionKey() {
      let arr = []
      if (this.detalisObj.examId == 'LHXG') {
        if (this.conditionWDData.length) {
          this.conditionWDData.map(item => {
            let obj_txt = item.code + '-' + item.checkRadio
            arr.push(obj_txt)
          })
        }
      }
      return arr.join()
    },
    conditionName() {
      let arr = []
      if (this.detalisObj.examId == 'LHXG') {
        if (this.conditionWDData.length) {
          this.conditionWDData.map(item => {
            let obj_txt = item.name + (item.checkRadio == 1 ? '(高)' : '(低)')
            arr.push(obj_txt)
          })
        }
      }
      return arr.join()
    }
  },

  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs.ruleForm.resetFields();
        this.params = {}
        this.innerVisible = false
      }
    }
  },

  created() {
    this.getAppraisalData();
    this.getWDList();
  },
  methods: {
    //过滤标签数据
    setHtmlData(str){
      let obj = ''
      if(str){
        obj = str.replace(/<[^<>]+>/g,'').replace(/&nbsp;/ig,'')
      }
      return obj
    },
    //区间设置对应内容
    handleTabClick() {
      this.getWDList();
    },

    removeQj(e, item) {
      if (item.examResultId) {
        this.$confirm("确认删除数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          const {data: resData} = await this.$delete(
              "exam/result/info/" + item.examResultId,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.$message.success("提交成功!");
          this.qjList.splice(e, 1)
        })
      } else {
        this.qjList.splice(e, 1)
      }
    },

    addQj() {
      let obj = {
        minScore: 0,
        maxScore: 0,
        title: '',
      }
      this.qjList.push(obj)
    },

    async initQjJZ() {
      this.loading = true;
      const {data: resData} = await this.$get(
          '/exam/result/list?examId=' + this.$route.query.examId + '&examDimensionCode=' + this.resue.code + '&resultType=ahrg'
      );
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.qjList = resData.data
      } else {
        this.qjList = [
          {
            minScore: 0,
            maxScore: 0,
            title: '低',
          },
          {
            minScore: 0,
            maxScore: 0,
            title: '高',
          }
        ]
      }
    },

    handQjEdit(index, item) {
      if (item.minScore == '') {
        this.$message.error('最小分数不能为空')
        return
      }
      if (!item.maxScore) {
        this.$message.error('最大分数不能为空')
        return
      }
      if (!item.title) {
        this.$message.error('名称不能为空')
        return
      }
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        if (item.examResultId) {
          let obj = {
            resultType: 'ahrg',
            examId: this.$route.query.examId,
            examDimensionCode: this.resue.code,
            minScore: item.minScore,
            maxScore: item.maxScore,
            title: item.title,
            examResultId: item.examResultId
          }
          const {data: resData} = await this.$put(
              "exam/result/info",
              obj,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.$message.success("提交成功!");
        } else {
          let obj = {
            resultType: 'ahrg',
            examId: this.$route.query.examId,
            examDimensionCode: this.resue.code,
            minScore: item.minScore,
            maxScore: item.maxScore,
            title: item.title,
            examResultId: item.examResultId
          }
          const {data: resData} = await this.$post(
              "exam/result/info",
              obj,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.$message.success("提交成功!");
        }
      })
    },
    /**
     * 点击基准
     */
    activeEventJz(index, code, name) {
      this.tagJzIndex = index;
      this.resueJz = {
        name,
        code,
      };
      this.params = {}
      this.innerVisible = false
      if (this.resue == "ZHWD_370") {
        this.getWdResultList();
      } else {
        this.getWdResultList(this.resue.code, code);
      }
    },
    /**
     * 获取基准列表
     */
    async getJZList(code) {
      this.getJZData = [];
      this.loading = true;
      const {data: resData} = await this.$get(`exam/datum/list`, {
        params: {
          examId: this.$route.query.examId,
          examDimensionCode: code,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data)
        this.getJZData = resData.data;
      // let obj = {
      //   name:'全部',
      //   code:''
      // }
      // this.getJZData.unshift(obj)

      /* tagJzIndex :激活的是哪个 基准  */
      if (this.getJZData.length != 0) {
        this.resueJz = {
          code: this.getJZData[this.tagJzIndex].code,
          name: this.getJZData[this.tagJzIndex].name,
        };
        this.getWdResultList(this.resue.code, this.resueJz.code);
      }

    },
    /**
     * 获取测评详情
     */
    async getAppraisalData() {
      this.loading = true;
      const {data: resData} = await this.$get(
          `exam/info/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.detalisObj = resData.data;
    },
    /**
     * 获取测评维度列表
     */
    async getWDList() {
      this.getWDData = [];
      this.loading = true;
      const {data: resData} = await this.$get(`exam/dimension/list`, {
        params: {
          examId: this.$route.query.examId,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        resData.data.map(item => {
          if (item.name != '综合') {
            this.getWDData.push(item)
          }
        })
        // this.getWDData = resData.data
      }
      /* tagIndex :激活的是哪个 维度  */
      if (this.getWDData.length != 0) {
        this.resue = {
          code: this.getWDData[this.tagIndex].code,
          name: this.getWDData[this.tagIndex].name,
        };
        this.getJZList(this.getWDData[this.tagIndex].code)
        this.initQjJZ()
      } else {
        this.tableData = [];
        return
      }
    },
    /**
     * 获取测评维度结果列表
     */
    async getWdResultList(examDimensionCode, examDatumCode) {
      this.loading = true;
      let temp = {examId: this.$route.query.examId,}
      if (emptyShow(examDimensionCode)) {
        temp.examDimensionCode = examDimensionCode
      }
      if (emptyShow(examDatumCode)) {
        temp.examDatumCode = examDatumCode
      }
      const {data: resData} = await this.$get(`exam/result/list`, {
        params: temp,
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.getWdResulData = resData.data;
      } else {
        this.getWdResulData = [];
      }
      // if (emptyShow(resData.data)) {
      //   this.getWdResulData = resData.data;
      // } else {
      //   this.getWdResulData = [];
      // }
    },
    /**
     * 点击维度
     */
    activeEvent(index, code, name) {
      this.params = {}
      this.innerVisible = false
      this.tagIndex = index;
      this.params.examDimensionCode = code;
      this.getJZList(code)
      this.resue = {
        name,
        code,
      };
      if (name == '综合') {
        this.getWdResultList()
      }
      this.initQjJZ()
    },

    async handleClick(type, row = {}) {
      this.clickType = type;
      this.params = {};
      this.dialogVisible = true;
      this.innerVisible = false
      if (type == "add") {
        this.params = {};
        this.innerVisible = true
      }
      if (type == "edit") {
        const {data: resData} = await this.$get(
            `exam/result/info/${row.examResultId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.params = resData.data;
        this.innerVisible = true
      }
    },
    /**
     * 编辑/增加
     */
    handleEdit() {
      if(parseInt(this.params.minScore) > parseInt(this.params.maxScore) ){
        this.$message.error('最小值不能大于最大值')
        return
      }
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "add") {
            this.params.examDimensionCode = this.resue.code;
            this.params.examDatumCode = this.resueJz.code;
            this.params.examId = this.$route.query.examId;
            const {data: resData} = await this.$post(
                "exam/result/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.getWdResultList(this.resue.code, this.resueJz.code);
            this.dialogVisible = false;
            this.$message.success("添加成功!");
            this.params = {};
          } else {
            const {data: resData} = await this.$put(
                "exam/result/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.getWdResultList(this.resue.code, this.resueJz.code);
            this.dialogVisible = false;
            this.$message.success("修改成功!");
          }
        });
      });
    },
    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `exam/result/info/${row.examResultId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("删除成功!");
        this.getWdResultList(this.resue.code);
      });
    },

    goBack() {
      this.$router.go(-1);
    },
    goTopic(){
      this.$router.push({
        name: "AHRG_LIST",
        query: {
          examId: this.$route.query.examId,
        },
      });
    },
    /**
     * 跳转结果设置
     */
    handelResultSet() {
      this.$router.push({
        name: "AHRGZS_SET",
        query: {
          examId: this.$route.query.examId,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.appraisal-title {
  color: #3a3a3a;
}

.appraisal-center {
  width: 90%;
  margin: 0 auto;
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}

.pub-marr {
  margin-top: 20px;
}

.marr {
  margin-top: 30px;
}

.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}

.subject {
  color: #8492a6;
  margin-left: 10px;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.activeBg {
  background: #b3d8ff;
  color: #fff;
}


.tag-marrs {
  border-color: #fbc4c4;
  color: #f56c6c;
}

.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}

.public-dialog-form_tans {
  .title_dun_dime {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }

  .dimension_box {
    display: flex;

    .dimension_box_lis {
      .dimension_content_list {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .dimension_title_info {
          width: 80px;
          text-align: right;
          margin-right: 10px;
        }
      }

      .button_bottom {
        margin-top: 20px;
        margin-left: 80px;
      }
    }
  }
}

.content_div {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.item_contents {
  display: flex;

  .remove_icon {
    margin-left: 10px;
  }
}

.input_item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;

  .name {
    margin-right: 5px;
  }
}


</style>
